import { clsx } from 'clsx'
import { Spinner } from 'component/Spinner'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { Doc } from 'page/catalog/BasicWelcomePage/Doc'
import { TimeoutModal } from 'page/catalog/BasicWelcomePage/TimeoutModal/TimeoutModal'
import { Powered } from 'page/catalog/Powered/Powered'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { SyntheticEvent } from 'react'
import { space } from 'util/typo'
import css from './WelcomeSochiPage.module.scss'

export const WelcomeSochiPage = observer(() => {
  const demo = useDemo()
  const { options, welcome } = demo
  const categories = options.categories ?? []

  const onClickPolicy = useLatestCallback((event: SyntheticEvent) => {
    event.preventDefault()
    if (welcome) welcome.doc = welcome.policy
  })

  const onClickData = useLatestCallback((event: SyntheticEvent) => {
    event.preventDefault()
    if (welcome) welcome.doc = welcome.data
  })

  return (
    <div className={css.page}>
      <div className={css.content}>
        <h1 className={css.title}>{i18n('demo.SelectCategory')}</h1>

        {!options.ready ? (
          <div className={css.spinner}>
            <Spinner />
          </div>
        ) : (
          <nav className={css.list}>
            <button
              type="button"
              className={clsx(css.button, css.all)}
              onClick={() => demo.pickCategory(null)}
            >
              {i18n('demo.AllCategories')}
            </button>
            {categories.map(({ value, label }) => (
              <button
                key={value}
                type="button"
                className={css.button}
                onClick={() => demo.pickCategory(value)}
              >
                {label || value}
              </button>
            ))}
          </nav>
        )}

        {welcome && (
          <p className={css.consent}>
            Выбирая категорию, вы подтверждаете, что ознакомились с
            {space}
            <span className={css.underline} onClick={onClickPolicy}>
              политикой конфиденциальности
            </span>
            {space}
            и даете
            {space}
            <span className={css.underline} onClick={onClickData}>
              согласие на обработку персональных данных
            </span>
          </p>
        )}
      </div>
      <Powered />
      {welcome?.doc && <Doc />}
      {welcome && !welcome.timeout.active && <TimeoutModal />}
    </div>
  )
})
